/**
 * Все цвета в preset обязаны лежать внутри colorScheme — плоские токены
 * перебиваются значениями Aura, и конфиг «не применяется».
 *
 * Тема проекта построена на CSS-переменных (--surface-card, --text-color, ...),
 * которые сами переключаются классом .app-dark, поэтому light и dark получают
 * один и тот же объект — дублировать значения не нужно.
 */
export const bothSchemes = <T>(tokens: T): { light: T; dark: T } => ({
  light: tokens,
  dark: tokens,
})
